module.exports = __webpack_public_path__ + "static/media/m-terradry.00f139b4.pdf";